import { Link } from "react-router-dom";
import { ShieldCheck, Award, Calculator, Sparkles, ArrowRight } from "lucide-react";

const TOOLS = [
  {
    to: "/tools/pdpl-readiness-check",
    icon: ShieldCheck,
    title: "PDPL Readiness Check",
    body: "12 yes / no / partial questions. Score out of 100, a traffic-light per section, and your top 3 gaps.",
    time: "3 minutes",
  },
  {
    to: "/tools/iso-27001-readiness",
    icon: Award,
    title: "ISO 27001 Readiness Score",
    body: "10 questions on control ownership, testing, policies and evidence. Get your readiness band and what to fix first.",
    time: "4 minutes",
  },
  {
    to: "/tools/software-cost-estimator",
    icon: Calculator,
    title: "Software Cost Estimator",
    body: "Choose project type, user roles, mobile, integrations and timeline. Indicative cost band in Omani Rials plus a timeline range.",
    time: "2 minutes",
  },
  {
    to: "/tools/ai-opportunity-finder",
    icon: Sparkles,
    title: "AI Opportunity Finder",
    body: "Pick your industry and pain points. We return 3 suggested AI use cases with an effort-vs-value rating.",
    time: "3 minutes",
  },
];

export default function ToolsIndex() {
  return (
    <div data-testid="tools-index-page">
      <section className="bg-white">
        <div className="mx-auto max-w-7xl px-4 py-20 lg:px-6 lg:py-28">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-wafa-carrot/10 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-wafa-carrot">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-wafa-carrot" />
              New free tools
            </div>
            <h1 className="mt-4 font-heading text-4xl font-semibold tracking-tight text-wafa-deep sm:text-5xl lg:text-6xl">
              Four short checks. Real answers, instantly.
            </h1>
            <p className="mt-5 text-base text-wafa-ink/80 lg:text-lg">
              We built these so you can see where you stand before you talk to anyone — including us.
              Every result is scored on-screen. No sales call required.
            </p>
          </div>

          <div className="mt-14 grid gap-6 md:grid-cols-2">
            {TOOLS.map(({ to, icon: Icon, title, body, time }) => (
              <Link
                key={to}
                to={to}
                data-testid={`tool-link-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group flex flex-col rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:border-wafa-deep/25 hover:shadow-[0_20px_50px_-20px_rgba(14,79,58,0.25)]"
              >
                <div className="flex items-center justify-between">
                  <div className="flex h-12 w-12 items-center justify-center rounded-md bg-wafa-cream/70 text-wafa-deep group-hover:bg-wafa-primary group-hover:text-white transition-colors">
                    <Icon className="h-6 w-6" />
                  </div>
                  <span className="rounded-full bg-wafa-cream px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-wafa-deep">
                    {time}
                  </span>
                </div>
                <div className="mt-6 font-heading text-2xl font-semibold text-wafa-deep">{title}</div>
                <p className="mt-3 text-sm text-wafa-ink/75">{body}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-wafa-deep">
                  Start check <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
